import {
  GET_COMPANIES,
} from "../actions/types";

const initialState = {
  companies: {},
};
const companiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPANIES:
      return {
        ...state,
        type: GET_COMPANIES,
        companies: action.companies,
      };
    default:
      return state;
  }
};
export default companiesReducer;
